import React from 'react';
import { type IIconProps } from '../../dm/icons.js';

// Same closed-book glyph as BibleIcon, scaled into the top-left, with a link badge in the
// bottom-right quadrant to distinguish it from the plain show/hide passage toggle.
export const BibleLinkIcon = ({ color, size, className }: IIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="scale(0.03125)">
        <polygon fill={color} points="481.771,313.228 257.896,430.587 261.287,437.071 485.162,319.697 " />
        <polygon fill={color} points="254.896,469.806 486.053,348.603 482.662,342.119 251.506,463.337 " />
        <path
          fill={color}
          d="M486.193,364.541L239.209,493.962c-7.5,1.906-5.781-3.953-5.797-13.125 c0.688-24.656,6.719-46.203,13.391-53.25L33.021,142.525c-9.563,11.453-17.781,47.094-10.969,85.891l211.125,281.515 c1.547,2.031,4.328,2.656,6.578,1.469l247.875-131.312c2.203-1.172,3.719-3.328,4.063-5.797s-0.516-4.953-2.328-6.688 L486.193,364.541z"
        />
        <path
          fill={color}
          d="M489.85,269.259L291.803,5.181c-3.813-5.078-10.766-6.656-16.391-3.688L45.803,122.431L259.6,407.494 l225.938-119.016c3.359-1.766,5.766-4.906,6.609-8.609C492.959,276.166,492.146,272.291,489.85,269.259z M310.818,280.572 l-62.516-83.359l-53.5,28.172l-24.25-32.328l53.5-28.172l-36.594-48.797l40.031-21.078l36.594,48.781l44.594-23.484l24.25,32.328 l-44.594,23.5l62.531,83.344L310.818,280.572z"
        />
      </g>
      <path
        transform="translate(14.5,14.5) scale(0.5)"
        fill={color}
        d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"
      />
      <path
        transform="translate(14.5,14.5) scale(0.5)"
        fill={color}
        d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"
      />
    </svg>
  );
};
